import React, { useEffect, useState, useCallback } from 'react';
import { useSnackbar } from 'notistack'; 
import { getHolidayList, saveHoliday, deleteHoliday } from '../../lib/api/holidayAction'; 
import { Box } from '@mui/material';
import HolidayMngGrid from '../../components/holydayMng/HolidayMngGrid';

const HolidayMngContainer = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [filterYear, setFilterYear] = useState(new Date().getFullYear());
    const [holidayList, setHolidayList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleFetchHolidays = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await getHolidayList(filterYear);
            if (response && response.data) {
                const resData = Array.isArray(response.data) ? response.data : (response.data.data || []);
                setHolidayList(resData);
            }
        } catch (error) {
            enqueueSnackbar('휴일 목록을 불러오는 중 오류가 발생했습니다.', { variant: 'error' });
        } finally {
            setIsLoading(false);
        }
    }, [filterYear, enqueueSnackbar]);

    const handleSaveHoliday = useCallback(async (holidayData) => {
        try {
            await saveHoliday(holidayData);
            enqueueSnackbar('휴일 정보가 성공적으로 저장되었습니다.', { variant: 'success' });
            handleFetchHolidays();
        } catch (error) {
            enqueueSnackbar('휴일 저장에 실패했습니다.', { variant: 'error' });
        }
    }, [handleFetchHolidays, enqueueSnackbar]);

    const handleDeleteHoliday = useCallback(async (holidayUuid) => {
        if (!window.confirm('선택한 휴일 정보를 정말로 삭제하시겠습니까?')) return;
        
        try {
            await deleteHoliday({ holidayUuid });
            enqueueSnackbar('휴일 정보가 삭제되었습니다.', { variant: 'success' });
            handleFetchHolidays();
        } catch (error) {
            enqueueSnackbar('휴일 삭제에 실패했습니다.', { variant: 'error' });
        }
    }, [handleFetchHolidays, enqueueSnackbar]);

    useEffect(() => {
        handleFetchHolidays();
    }, [handleFetchHolidays]);

    return (
        <Box sx={{ width: '100%', height: '100%', p: 2, backgroundColor: '#ffffff' }}>
            <HolidayMngGrid 
                holidayList={holidayList}
                isLoading={isLoading}
                filterYear={filterYear}
                setFilterYear={setFilterYear}
                onSave={handleSaveHoliday}
                onDelete={handleDeleteHoliday}
                onRefresh={handleFetchHolidays}
            />
        </Box>
    );
};

export default HolidayMngContainer;
